import MypageRecentlySawContainer from './MypageRecentlySawContainer';
export default MypageRecentlySawContainer;
